// extracted by mini-css-extract-plugin
export default {"sort":"lX-z","sortSelect":"mX-z","disabled":"nX-z"};